// controllers/size-controller.ts
import { BreakPoint, getDevice, windowSize } from "@adornis/base/client/frontend-helpers";
import "@lit/reactive-element";
import "lit";
import { combineLatest, debounceTime, map, Observable, shareReplay, startWith } from "rxjs";
var SizeController = class {
  constructor(host) {
    this._domRectObservable = new Observable(
      (subscriber) => new ResizeObserver((entries) => subscriber.next(entries[0].contentRect)).observe(this.host)
    ).pipe(
      debounceTime(25),
      startWith({
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0
      }),
      shareReplay(1)
    );
    this._windowSizeObservable = windowSize.pipe(
      map((windowSize2) => windowSize2.width),
      startWith(window.innerWidth),
      map((width) => getDevice(width)),
      shareReplay(1)
    );
    (this.host = host).addController(this);
    this._startSubscriptions();
  }
  get isTablet() {
    return this.device <= BreakPoint.tablet;
  }
  get isMobile() {
    return this.device < BreakPoint.tablet;
  }
  get isMobileSmall() {
    return this.device < BreakPoint.smallPhone;
  }
  get isLandscape() {
    if (this.height && this.width && this.height < this.width)
      return true;
    return false;
  }
  get observable() {
    return combineLatest([this._domRectObservable, this._windowSizeObservable]).pipe(
      map(([domRect, windowWidth]) => ({
        bottom: domRect.bottom,
        height: domRect.height,
        left: domRect.left,
        right: domRect.right,
        top: domRect.top,
        width: domRect.width,
        x: domRect.x,
        y: domRect.y,
        componentDevice: getDevice(domRect.width),
        device: getDevice(windowWidth)
      }))
    );
  }
  hostConnected() {
    this._stopSubscriptions();
    this._startSubscriptions();
  }
  hostDisconnected() {
    this._stopSubscriptions();
  }
  _startSubscriptions() {
    this._subscription = this._domRectObservable.subscribe((size) => {
      this.size = size;
      this.width = size.width;
      this.height = size.height;
      this.componentDevice = getDevice(size.width);
      this.host.requestUpdate();
    });
    this._windowSizeObservable.subscribe((device) => {
      this.device = device;
      this.host.requestUpdate();
    });
  }
  _stopSubscriptions() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = void 0;
    }
    if (this._windowSizeSubscription) {
      this._windowSizeSubscription.unsubscribe();
      this._windowSizeSubscription = void 0;
    }
  }
};
export {
  SizeController
};
